export const typography = {
  fonts: {
    body: `Quicksand, sans-serif`,
    heading: `'Cormorant Garamond', serif`,
  },
  fontSizes: {
    desktop: {
      h1: `4.75rem`,
      h2: `3.5rem`,
      h3: `2.5rem`,
      h4: `1.75rem`,
      h5: `1.5rem`,
      h6: `1.25rem`,
    },
    mobile: {
      h1: `3rem`,
      h2: `2.25rem`,
      h3: `1.75rem`,
      h4: `1.25rem`,
      h6: `1.125rem`,
    },
    text: {
      1: `1.375rem`,
      2: `1.125rem`,
      3: `1rem`,
      4: `0.875rem`,
      5: `0.75rem`,
    },
  },
};
